import React from "react";

// Selectable product cards with image + name. value=array of product ids
export function ProductGrid({ products, selected = [], onChange, testid = "product-grid" }) {
  const toggle = (id) =>
    onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  const allSelected = products.length > 0 && selected.length === products.length;
  return (
    <div className="space-y-3" data-testid={testid}>
      <button
        type="button"
        data-testid={`${testid}-select-all`}
        onClick={() => onChange(allSelected ? [] : products.map((p) => p.id))}
        className="text-sm font-semibold text-emerald-600"
      >
        {allSelected ? "Clear All" : "Select All"}
      </button>
      <div className="grid grid-cols-2 gap-3">
        {products.map((p) => {
          const active = selected.includes(p.id);
          return (
            <button
              key={p.id}
              type="button"
              data-testid={`${testid}-item-${p.id}`}
              onClick={() => toggle(p.id)}
              className={`text-left rounded-xl border p-2 transition-colors active:scale-95 ${
                active ? "border-emerald-600 ring-2 ring-emerald-500/30 bg-emerald-50" : "border-slate-200 bg-white"
              }`}
            >
              <div className="h-20 w-full rounded-lg bg-slate-100 overflow-hidden mb-2">
                {p.image ? (
                  <img src={p.image} alt={p.name} className="h-full w-full object-cover" />
                ) : null}
              </div>
              <div className="text-sm font-semibold text-slate-800 leading-tight">{p.name}</div>
              <div className="text-xs text-slate-500">{p.pack_size}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
